import { render } from "./App.vue?vue&type=template&id=9f58c0f8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=9f58c0f8&lang=less"
script.render = render

export default script